"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var Ticks = function TicksForRangeInput(_ref) {
  var classPrefix = _ref.classPrefix,
      steps = _ref.steps;
  var nodes = [];

  for (var i = 0; i < steps.length; i += 1) {
    nodes.push( /*#__PURE__*/_react["default"].createElement("div", {
      key: (0, _uuid.v4)(),
      className: "".concat(classPrefix, "__tick-wrapper")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(classPrefix, "__tick")
    })));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classPrefix, "__ticks-wrapper")
  }, nodes);
};

Ticks.propTypes = {
  classPrefix: _propTypes["default"].string.isRequired,
  steps: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    pixels: _propTypes["default"].number,
    threshold: _propTypes["default"].number,
    value: _propTypes["default"].number
  })).isRequired
};
var _default = Ticks;
exports["default"] = _default;